import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "input" }
const _hoisted_3 = ["value", "data-maska", "type", "placeholder"]

import {Component, computed, ref} from "vue";
import {IComponentInputEmits, IComponentSearchProps} from "@/types/main";
import {vMaska} from 'maska'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSearch',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Placeholder" },
    icon: {},
    type: { default: "text" },
    width: { default: "329px" },
    height: { default: "44px" },
    additionalStyle: {},
    appendIcon: {},
    mask: {}
  },
  emits: ["update:modelValue", "focus", "blur", "appendIconClick", "mask:completed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isFocused = ref(false);

const customStyle = computed(() => {
  return {
    width: props.width,
    height: props.height,
    ...props.additionalStyle,
  };
});

const emit = __emit;

const appendIconClick = () => {
  emit("appendIconClick")
}

const onInput = (e: Event) => {
  emit(
      "update:modelValue",
      (e.target as HTMLInputElement | HTMLTextAreaElement).value
  );
}

const onFocus = () => {
  isFocused.value = true;
  emit("focus");
}

const onBlur = () => {
  isFocused.value = false;
  emit("blur");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", null, [
    _createElementVNode("div", {
      class: "c-cu-search",
      style: _normalizeStyle(customStyle.value)
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), { size: 20 }))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          value: __props.modelValue,
          id: "custom_search",
          "data-maska": __props.mask,
          type: __props.type,
          placeholder: __props.placeholder,
          onInput: onInput,
          onFocus: onFocus,
          onBlur: onBlur
        }, null, 40, _hoisted_3), [
          [_unref(vMaska)]
        ]),
        (__props.appendIcon)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "append-icon",
              onClick: appendIconClick
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(__props.appendIcon), { size: 20 }))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}
}

})